<template>

    <router-view
        v-if="loaded"
        @updateCrmGroups="updateCrmGroups"
    ></router-view>

</template>

<script>

import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';

export default {

    computed: {
        ...mapGetters([
            'getCrmGroups',
        ]),
    },

    data() {
        return {
            loaded:false,
        }
    },

    methods: {

        ...mapActions([
            'setCrmGroups',
        ]),

        checkCrmGroups() {
            if (this.getCrmGroups.length === 0) {
                this.fetchCrmGroups();
            } else {
                this.loaded = true;
            }
        },

        fetchCrmGroups() {
            axios.get(this.route('api.v1.crm.groups.index'))
            .then(resp => {
                this.setCrmGroups(resp.data.data);
                this.loaded = true;
            });
        },

        updateCrmGroups() {
            this.loaded = false;
            this.fetchCrmGroups();
        },

    },

    mounted(){
        this.checkCrmGroups();
    },

    name:'CrmGroupsLayout',

}

</script>
